import cloneDeep from 'lodash.clonedeep';
import uuidv4 from 'uuid/v4';
import {
  defaultCanvasColor,
  defaultCanvasColorTo,
  defaultCanvasColorFrom,
  defaultBackgroundType,
  defaultBackgroundGradientType
} from 'JS/config/defaults';

export default function createNewScene(scribe, sceneIds) {
  const newActiveScribe = cloneDeep(scribe);
  const activeScene = newActiveScribe.scenes.find(scene => scene.active);
  const activeSceneIndex = newActiveScribe.scenes.findIndex(scene => scene.active);
  const newScene = cloneDeep(activeScene);

  newScene.id = uuidv4();
  newScene.elementIds = [];
  newScene.settings.backgroundColor = defaultCanvasColor;
  newScene.settings.backgroundColorTo = defaultCanvasColorTo;
  newScene.settings.backgroundColorFrom = defaultCanvasColorFrom;
  newScene.settings.backgroundType = defaultBackgroundType;
  newScene.settings.backgroundGradientType = defaultBackgroundGradientType;
  newScene.thumbnailImage = null;

  activeScene.active = false;

  if (sceneIds.length === 0) {
    const addSceneIndex = activeSceneIndex + 1;

    newActiveScribe.scenes.splice(addSceneIndex, 0, newScene);
  } else {
    let activeSceneIndexes = [];

    for (const sceneId of sceneIds) {
      activeSceneIndexes.push(newActiveScribe?.scenes.findIndex(scene => scene?.id === sceneId));
    }
    const addSceneIndex = Math.max(...activeSceneIndexes) + 1;

    newActiveScribe.scenes.splice(addSceneIndex, 0, newScene);
  }

  return { newActiveScribe, sceneId: newScene.id };
}
